import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './app-layout/layout/layout.component'
import { AuthGuard } from './_guards/auth.guard';
import { LogoutGuard } from './_guards/logout.guard';
import { UserConfigResolve } from './_services/user-config-resolve.service';
import { VaListResolve } from './_services/va-list-resolve.service';
import { ListVaComponent } from './list-va/list-va.component';
import { TrashComponent } from './trash/trash.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ProjectComponent} from './project/project.component';
import { ReleaseHistoryComponent } from './release-history/release-history.component';


const routes: Routes = [
	{ path: '', redirectTo: 'list-va', pathMatch: 'full' },
	{ path: 'auth', loadChildren: './auth/auth.module#AuthModule', canActivate: [LogoutGuard], runGuardsAndResolvers: 'always', },
	{path: 'cira-release-history', component: ReleaseHistoryComponent, canActivate: [AuthGuard] },
	{
		path: '',
		resolve: {
			config: UserConfigResolve,
			agents: VaListResolve
		},
		canActivate: [AuthGuard],
		component: LayoutComponent,
		children: [
			{ path: 'list-va', component: ListVaComponent,
			},
			{path:'user-profile',component: UserProfileComponent },
			{path: 'trash',component: TrashComponent}
		]
	},
	{
		path: 'project/:id',
		canActivate: [AuthGuard],
		loadChildren: './project/project.module#ProjectModule',
		component: ProjectComponent
	},
	{
		path: '**',
		redirectTo: 'list_va/'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
	exports: [RouterModule]
})

export class AppRoutingModule { }
